import React, { useEffect } from 'react'
import { remove } from 'local-storage'
import { useUserDispatcher } from '@hooks'

const SignOut: React.FC = () => {
    const { clearUserAuthData } = useUserDispatcher()

    useEffect(() => {
        remove('token')
        remove('refreshToken')
        clearUserAuthData()
    }, [])
    
    return (<div>Signout</div>)
}

export default SignOut